import React, { useState, useEffect } from 'react';
import { getShopProducts } from '../../../../api/shop';
import './CategoryProductsStyleguide.scss';
import { getSmartImage } from '../../../../helpers/helpers';

export const CategoryProductsStyleguide = ({ categoryId }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const getProducts = async () => {
      const { results } = await getShopProducts({ limit: 6, tab: 'popular', Category_id: categoryId });
      setProducts(results);
    };

    getProducts();
  }, [categoryId]);

  if (!categoryId) {
    return null;
  }

  return (
    <div className='category-products-styleguide'>
      <h1>Top products in this category</h1>
      <p>Make sure to keep the image style uniform</p>

      <div className='products'>
        {products.map(product => (
          <div className='product' key={product.id}>
            <img src={getSmartImage(product.image)} alt={product.name} />
          </div>
        ))}
      </div>
    </div>
  );
};
